import React from 'react';

export default function IncidentRate({ className }) {
    return (
        <svg
            className={`w-6 h-6 text-gray-400 ${className} `}

            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
        >
            <defs>
                <style>
                    {`
                        .cls-1 { fill: #0077ef; }
                        .cls-2 { fill: #fff; fill-rule:evenodd; }
                    `}
                </style>
            </defs>
            <circle className="cls-1" cx="50" cy="50" r="50" />
            <g
                id="Icon_Charts-and-Graphs_g-icon-bar-chart-report"
                data-name="Icon/Charts-and-Graphs/g-icon-bar-chart-report"
            >
                <g id="Combined-Shape">
                    <path
                        id="path-1"
                        className="cls-2"
                        d="M34.54,30V66.62H71.17V71.2H30V30ZM46,43.73V62H39.12V43.73Zm11.45,9.16V62H50.56V52.89Zm11.45,0V62H62V52.89ZM59.72,27.7,71.17,39.15,59.72,50.6,48.27,39.15Zm0,14.88a1.15,1.15,0,1,0,1.14,1.15A1.15,1.15,0,0,0,59.72,42.58Zm0-9.15a1.14,1.14,0,0,0-1.14,1.14h0V40.3a1.14,1.14,0,0,0,2.28,0h0V34.57A1.14,1.14,0,0,0,59.72,33.43Z"
                    />
                </g>
            </g>
        </svg>
    );
}
